export interface StockEnquiryProductHistory {
  transactionDate: Date;
  transactionNumber: number;
  transactionSequence: number;
  transactionType: string;
  transactionQty: number;
  runningTotal: number;
  stockAdjustmentReason: string;
  pricePerUnit: number;
  warehouse: string;
  location: string;
  batchNo: string;
  grade: string;
  stockNo: string;
  makeUp: string;
  user: string;
  comments: string;
  documentDate: Date;
}
